import {Component, Input, Output, ElementRef, OnInit, OnChanges, EventEmitter} from '@angular/core';
import {WindowService} from "../services/window.service";
import {Logger} from "../utils/logger";
import {MainConfigurationInterface} from "../services/configuration.loader";

@Component({
    selector: 'product_details',
    templateUrl: "./product_detail.component.html"
})
export class ProductDetailPanel implements OnInit, OnChanges{

    @Input('show')
    // public needShow = true;
    public isShown = false;

    @Output('onHide')
    public displayEvent:EventEmitter<boolean>;

    @Input()
    public product = null;

    @Input()
    public subProduct = null;

    @Input()
    public configuration: MainConfigurationInterface;

    public config;

    constructor(public el: ElementRef, public windowService: WindowService, public logger: Logger){
        this.displayEvent = new EventEmitter<boolean>();
    }
    ngOnChanges(changes: any):any {
        // if (typeof changes.needShow !== 'undefined') {
        //     if (changes.needShow.currentValue && changes.needShow.currentValue !== changes.needShow.previousValue) {
        //         this.show();
        //     } else {
        //         this.hide();
        //     }
        // }
    }


    ngOnInit():any {

    }

    hide() {
        this.displayEvent.emit(true);
        // let s = this.el.nativeElement;
        // this.animator.setType("fadeOut").hide(s).then(()=> {
        //     this.isShown = false;
        //     this.displayEvent.emit(true);
        // });
    }

    show() {
        // this.isShown = true;
        // let s = this.el.nativeElement;
        // this.animator.setType("fadeIn").show(s).then(()=> {
        //
        // });
    }

}



// WEBPACK FOOTER //
// ./src/app/product_detail/product_detail.component.ts